import { ComponentProps } from 'react';

import { Badge, Tab } from '@pukka/ui-components';
import { useSnapshot } from 'valtio';

import { PaymentState } from './BillingReceipt.state';

interface BillingHeaderProps {
  readonly disabled: boolean;
  readonly className?: string;
  readonly disableRecurring?: boolean;
}

const data = [
  {
    value: 'recurring',
    title: 'Recurring',
    subtitle: 'Monthly/yearly hassle-free payments',
    children: <Badge text="Recommended" color="green" size="xs" className="absolute right-2 top-2" />,
  },
  {
    value: 'regular',
    title: 'Regular',
    subtitle: 'Paid manually every month/year',
  },
] satisfies ComponentProps<typeof Tab.Billing>['data'];

const disabledRecurringData = [
  {
    value: 'recurring',
    title: 'Recurring',
    subtitle: 'Monthly/yearly hassle-free payments',
    children: <Badge text="Coming soon" color="green" size="xs" className="absolute right-2 top-2" />,
    disabled: true,
  },
  {
    value: 'regular',
    title: 'Regular',
    subtitle: 'Paid manually every month/year',
  },
] satisfies ComponentProps<typeof Tab.Billing>['data'];

function BillingHeader({ disabled, className, disableRecurring }: BillingHeaderProps) {
  const { type } = useSnapshot(PaymentState);
  const { onChangePaymentType } = PaymentState;

  const tabData = disableRecurring ? disabledRecurringData : data;

  return (
    <Tab.Billing
      disabled={disabled}
      data={tabData}
      value={type}
      onChange={onChangePaymentType as (val: string) => void}
      className={className}
    />
  );
}

export { BillingHeader };
